import { IconButton, Tooltip } from '@material-ui/core'
import ReactMarkdownV2 from '_/components/react-markdown-v2'
import Svg from '_/components/svg'
import QuestionIcon from '_assets/svgs/question-circle-blue.svg'
import WarningBlueIcon from '_assets/icons/ic-warning-blue.svg'
import React, { useCallback } from 'react'
import useStyles from './styles'

/**
 * Question button with info popup on hover.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.title - Tooltip content.
 * @param {string} [props.placement='bottom'] - Tooltip position.
 * @param {boolean} [props.markdown=false] - Whether to render the title as markdown.
 * @param {boolean} [props.compact=true] - Remove vertical margin for a more compact rendering.
 * @param {React.CSSProperties} [props.style={}] - Additional styles for the button.
 * @returns {JSX.Element} Rendered HelpInfoButton component.
 */
const HelpInfoButton = ({
  title,
  placement = 'bottom',
  markdown = false,
  compact = true,
  style = {},
  icon = 'question',
  onClick = () => {},
}) => {
  const styles = useStyles()
  const svgIcon = icon === 'warning' ? WarningBlueIcon : QuestionIcon

  /**
   * Generates the margin style based on the placement.
   * @returns {React.CSSProperties} Margin style for the tooltip.
   */
  const generateMarginStyle = useCallback(() => {
    switch (placement) {
      case 'top':
        return { marginBottom: -7 }
      case 'bottom':
        return { marginTop: -7 }
      case 'left':
        return { marginRight: -7 }
      case 'right':
        return { marginLeft: -7 }
      default:
        return {}
    }
  }, [placement])

  const generateTooltipStyle = useCallback(() => {
    return {
      padding: 6,
      ...(compact
        ? {
            marginTop: -6,
            marginBottom: -6,
          }
        : {}),
      ...style,
    }
  }, [compact, style])

  return (
    <Tooltip
      title={markdown ? <ReactMarkdownV2>{title}</ReactMarkdownV2> : title}
      placement={placement}
      PopperProps={{ style: generateMarginStyle() }}
      style={generateTooltipStyle()}
    >
      <IconButton onClick={onClick}>
        <Svg icon={svgIcon} className={styles.supportIcon} />
      </IconButton>
    </Tooltip>
  )
}

export default HelpInfoButton
